import { gql } from '@/__generated__';

export const GET_ORGANIZATION_PREFERENCES_VISIBLE_UNITS = gql(`#graphql
  query GetOrganizationPreferencesVisibleUnits($input: OrganizationInput) {
    organization(input: $input) {
      id
      preferences {
        id
        visibleUnits
        defaultValues: visibleUnits(defaultValues: true)
      }
    }
  }
`);
